import { get } from 'Api';

export const MEGA_MENU_PRODUCTS = 'frontend/mega-menu-products/MEGA_MENU_PRODUCTS';

const isAltRank = false;

export function algoliaBackendCall() {
  return dispatch => get(dispatch, `/algolia/megamenu?altRank=${isAltRank}`, true)
    .then(({ response, data }) => {
      if (response && data) {
        return data;
      }
      return false;
    });
}
